export default {
  1: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '3.25rem',
        right: '3.0rem',
      },
    },
  },
  2: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '3.25rem',
        right: '3.0rem',
      },
      1: {
        bottom: '3.25rem',
        right: '2.25rem',
      },
    },
  },
  3: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '3.25rem',
        right: '3.0rem',
      },
      1: {
        bottom: '3.25rem',
        right: '2.25rem',
      },
      2: {
        bottom: '3.25rem',
        right: '1.5rem',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/circleStylesProvenCatalog.ts